<ng-container *ngIf="(advertisement$ | async) as ad">
    <div class="payhoa-side-advertisement d-flex flex-column align-items-center py-3 animated fadeIn"
         [style.background-color]="ad.color">
        <!--app-button type="link"
                    class="ml-auto mr-0"
                    [icon]="'close'"
                    [buttonClasses]="['inverse', 'mr-0', 'px-2']"
                    (onClick)="dismissAd(ad.id)"></app-button-->
        <div class="side-ad-image mt-3">
            <img [src]="ad.imgSrc">
        </div>
        <div class="side-ad-text mx-3">{{ ad.tagline }}</div>
        <app-button class="m-3"
                    [buttonClasses]="['mr-0']"
                    (onClick)="openAd(ad.id)">{{ ad.cta.text }}</app-button>
    </div>
</ng-container>
